<template>
  <div class="flex flex-col h-full">
    <div class="w-full h-2/3">
      <img src="/images/sign-in.png" class="object-cover h-full mx-auto">
    </div>
    <div class="px-16 text-center pb-56 fixed bottom-0 right-0 left-0">
      <div class="headline-xl mb-8">
        Du måste logga in för att komma åt den här sidan
      </div>
      <div class="base text-dark mb-24">
        Att skapa konto är gratis och enkelt och låser upp alla funktioner för dig i appen.
      </div>
      <Button
        type="primary"
        :text="'Skapa konto / Logga in'"
        :icon="logIn"
        @click="goToLogin"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  IonContent,
  useIonRouter
} from '@ionic/vue';
import { logIn } from 'ionicons/icons';
import Button from '@/components/Button.vue';

const ionRouter = useIonRouter();

const goToLogin = () => {
  ionRouter.replace('/auth');
};

</script>
